// extracted by mini-css-extract-plugin
module.exports = {"green":"m4i0h7rBf3WNZDKp4CgOe","red":"_1WdJum9o-17fk7MBVMkn1w"};